import { render, staticRenderFns } from "./itemUpdate.vue?vue&type=template&id=e32022e0&scoped=true"
import script from "./itemUpdate.vue?vue&type=script&lang=js"
export * from "./itemUpdate.vue?vue&type=script&lang=js"
import style0 from "./itemUpdate.vue?vue&type=style&index=0&id=e32022e0&prod&scoped=true&lang=css"
import style1 from "./itemUpdate.vue?vue&type=style&index=1&id=e32022e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32022e0",
  null
  
)

export default component.exports